"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AuthenticationInput = void 0;
const typebox_1 = require("@sinclair/typebox");
exports.AuthenticationInput = typebox_1.Type.Union([
    typebox_1.Type.Object({
        cognitoToken: typebox_1.Type.String(),
    }),
    typebox_1.Type.Object({
        idToken: typebox_1.Type.String(),
    }),
]);
//# sourceMappingURL=authentication.js.map